import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Container,
} from '@mui/material';

// We'll use CDN links for the Material UI libraries.
// In a real project, you would install these via npm.
// The code below imports the necessary components directly.

const dashboardFeatures = [
  {
    title: 'View Orders',
    description: 'Review and manage incoming orders from various clients. Acknowledge new orders to begin the fulfillment process.',
    image: 'https://placehold.co/400x300/e2e8f0/334155?text=Orders',
  },
  {
    title: 'Add Products',
    description: 'Quickly upload new products, set pricing, and add detailed descriptions and images to your inventory.',
    image: 'https://placehold.co/400x300/e2e8f0/334155?text=Add+Products',
  },
  {
    title: 'Update Inventory',
    description: 'Easily update stock levels for all your products. Keep your listings accurate to prevent overselling.',
    image: 'https://placehold.co/400x300/e2e8f0/334155?text=Inventory',
  },
  {
    title: 'Manage Deliveries',
    description: 'Track the status of your shipments and get real-time updates. Coordinate with delivery partners for smooth logistics.',
    image: 'https://placehold.co/400x300/e2e8f0/334155?text=Deliveries',
  },
  {
    title: 'View Analytics',
    description: 'Access detailed reports on your sales performance, popular products, and revenue trends.',
    image: 'https://placehold.co/400x300/e2e8f0/334155?text=Analytics',
  },
  {
    title: 'Manage Profile',
    description: 'Update your company information, contact details, and payment preferences.',
    image: 'https://placehold.co/400x300/e2e8f0/334155?text=Profile',
  },
];

const AdminGuidelines = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#f1f5f9', // Corresponds to slate-100
        fontFamily: 'Inter, sans-serif',
        padding: { xs: 2, md: 4 }, // Responsive padding
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
      `}</style>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 4,
          padding: 4,
          backgroundColor: 'white',
          borderRadius: 4,
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        }}
      >
        <Box>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
            Welcome, Admin!
          </Typography>
          <Typography variant="body1" sx={{ color: '#475569', marginTop: 0.5 }}>
            Here is a quick overview of your account.
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={3}>
        {dashboardFeatures.map((feature, index) => (
          <Grid item xs={12} md={6} lg={4} key={index}>
            <Card
              sx={{
                borderRadius: 4,
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: 3,
                height: '100%',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  overflow: 'hidden',
                  borderRadius: 3,
                  marginBottom: 2,
                }}
              >
                <img
                  src={feature.image}
                  alt={feature.title}
                  style={{ width: '100%', height: 'auto', objectFit: 'cover', borderRadius: 'inherit' }}
                />
              </Box>
              <CardContent sx={{ flexGrow: 1, padding: 0 }}>
                <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: '#1e293b', marginBottom: 1 }}>
                  {feature.title}
                </Typography>
                <Typography variant="body2" sx={{ color: '#475569' }}>
                  {feature.description}
                </Typography>
              </CardContent>
              <Button
                variant="contained"
                sx={{
                  marginTop: 2,
                  backgroundColor: '#cbd5e1',
                  color: '#475569',
                  fontWeight: 'semibold',
                  borderRadius: '9999px',
                  '&:hover': {
                    backgroundColor: '#94a3b8',
                  },
                }}
              >
                Go to {feature.title}
              </Button>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AdminGuidelines;